// Fichier : Camera.js (Corrigé)

import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";

export default class Camera {
  constructor(canvas, scene, experience, fov = 35, near = 0.1, far = 100) {
    // Setup
    this.experience = experience;
    this.debug = this.experience.debug;
    this.sizes = this.experience.sizes;

    this.canvas = canvas;
    this.scene = scene;

    // On sauvegarde les paramètres pour les utiliser plus tard dans setInstance()
    this.fov = fov;
    this.near = near;
    this.far = far;
    // -------------------

    // État de la caméra
    this.isFree = false;
    this.cinematicPosition = new THREE.Vector3();
    this.cinematicTarget = new THREE.Vector3();

    this.setInstance();
    this.setControls();
  }

  setInstance() {
    this.instance = new THREE.PerspectiveCamera(
      this.fov,
      this.sizes.width / this.sizes.height,
      this.near,
      this.far
    );
    this.scene.add(this.instance);
    
  }

  setControls() {
    this.controls = new OrbitControls(this.instance, this.canvas);
    this.controls.enableDamping = true;
    this.controls.enabled = false;
  }

  setCinematicState(position, target) {
    this.cinematicPosition.copy(position);
    this.cinematicTarget.copy(target);
    this.instance.position.copy(this.cinematicPosition);
    this.controls.target.copy(this.cinematicTarget);
  }

  enableFreeOrbit() {
    this.isFree = true;
    this.controls.enabled = true;
  }

  disableFreeOrbit() {
    this.isFree = false;
    this.controls.enabled = false;
    this.instance.position.copy(this.cinematicPosition);
    this.controls.target.copy(this.cinematicTarget);
  }

  toggleFreeOrbit() {
    if (this.isFree) {
      this.disableFreeOrbit();
    } else {
      this.enableFreeOrbit();
    }
  }

  resize() {
    this.instance.aspect = this.sizes.width / this.sizes.height;
    this.instance.updateProjectionMatrix();
  }

  update() {
    this.controls.update();
  }

  setDebug() {
    this.debug.ui
      .add({ toggle: () => this.toggleFreeOrbit() }, "toggle")
      .name("Toggle Free Camera");
  }
}
